module.exports = __webpack_public_path__ + "img/9a112d7.jpg";